module.exports = {
    AUTH                        : "auth",
    REFRESH_TOKEN               : "refresh_auth_token",
    GET_UI_CFG_VERSION          : "get_ui_cfg_version",
    GET_UI_CFG                  : "get_ui_cfg",
    GET_PARAM                   : "get_param",
    GET_ALL_UI_PARAMS           : "get_all_ui_params",
    GET_ALL_UI_USERS            : "get_users",
    SET_PARAM                   : "set_param",
    UPD_PARAM                   : "upd_param",
    UPD_UI_CFG_VERSION          : "upd_ui_cfg_version",
    ADD_USER                    : "add_user",
    DELETE_USER                 : "delete_user",
    GET_NEW_SOFTWARE            : "get_new_software",
    CMD_UPDATE_SOFTWARE         : "cmd_update_software",
    UPD_UPDATE_SOFTWARE_FINISH  : "upd_update_software_finish",
    GET_SERVER_WORK_STATE       : "get_server_work_state",
    UPD_NEW_SOFTWARE            : "upd_new_software",
    UPD_SERVER_WORK_STATE       : "upd_server_work_state",
    CMD_CHECK_NEW_SOFTWARE      : "cmd_check_new_software",
    UPD_UPDATE_SOFTWARE_PROGRESS: "upd_update_software_progress",
    GET_PARAM_HISTORY           : "get_param_history"
}